import { getEnv } from "@/utils/env"

export const UUID: string = crypto.randomUUID()

export const VIZ_NOW_ACCOUNT_ID = getEnv("VUE_APP_ONBOARDING_VIZ_NOW_ACCOUNT_ID")
